(function () {
	function initGallery(block) {
		var galleryRowsContainer = block.querySelector('.image-rows');
		var viewMoreButtonWrapper = block.querySelector('.view-more-wrap');
		var viewMoreButton = block.querySelector('.view-more-btn');
		if (!galleryRowsContainer || !viewMoreButtonWrapper || !viewMoreButton) return;
		if (viewMoreButton.dataset.breezeBound === 'true') return;

		var remainingImages = JSON.parse(
			galleryRowsContainer.getAttribute('data-remaining') || '[]'
		);
		var currentImageIndex = 0;

		if (remainingImages.length === 0) {
			viewMoreButtonWrapper.style.display = 'none';
			return;
		}

		viewMoreButton.dataset.breezeBound = 'true';
		viewMoreButton.addEventListener('click', function (event) {
			event.preventDefault();

			var nextImages = remainingImages.slice(currentImageIndex, currentImageIndex + 5);
			if (nextImages.length === 0) {
				viewMoreButtonWrapper.style.display = 'none';
				return;
			}

			var newGalleryRow = document.createElement('div');
			newGalleryRow.className = 'gallery-row';

			var bigImageHTML = nextImages[0]
				? '<figure class="gallery-single"><a href="' + nextImages[0].src + '" data-fancybox="image-gallery"><img class="gallery-img" src="' + nextImages[0].src + '" alt="' + (nextImages[0].alt || '') + '"></a></figure>'
				: '<figure class="gallery-single gallery-empty"></figure>';

			var smallImagesHTML = '<div class="gallery-quad">';
			for (var i = 1; i < 5; i++) {
				var smallImage = nextImages[i];
				smallImagesHTML += smallImage
					? '<figure class="gallery-cell"><a href="' + smallImage.src + '" data-fancybox="image-gallery"><img class="gallery-img" src="' + smallImage.src + '" alt="' + (smallImage.alt || '') + '"></a></figure>'
					: '<figure class="gallery-cell gallery-empty"></figure>';
			}
			smallImagesHTML += '</div>';

			newGalleryRow.innerHTML = bigImageHTML + smallImagesHTML;
			galleryRowsContainer.appendChild(newGalleryRow);

			currentImageIndex += nextImages.length;
			if (currentImageIndex >= remainingImages.length) {
				viewMoreButtonWrapper.style.display = 'none';
			}
		});
	}

	function initAllGalleries(root) {
		var scope = root || document;
		var blocks = scope.querySelectorAll('.block-image-gallery');
		if (!blocks.length) return;
		blocks.forEach(initGallery);
	}

	initAllGalleries();

	// Re-init when a tab is shown (tabs can hide panes before JS binds).
	document.addEventListener('shown.bs.tab', function (event) {
		var target = event && event.target;
		if (!target || !target.getAttribute) return;
		var paneSelector = target.getAttribute('data-bs-target');
		if (!paneSelector) return;
		var pane = document.querySelector(paneSelector);
		if (!pane) return;
		initAllGalleries(pane);
	});

	// Re-init when a tab accordion pane opens on mobile.
	document.addEventListener('shown.bs.collapse', function (event) {
		var pane = event && event.target;
		if (!pane || !pane.querySelectorAll) return;
		initAllGalleries(pane);
	});
})();
  
